import React from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'

type TallyBulkDeleteConfirmProps = {
  open: boolean
  selectedCount: number
  deletableCount: number
  linxupSkippedCount: number
  deleting?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const TallyBulkDeleteConfirm: React.FC<TallyBulkDeleteConfirmProps> = ({
  open,
  selectedCount,
  deletableCount,
  linxupSkippedCount,
  deleting = false,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null

  return createPortal(
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 p-4"
      onClick={() => {
        if (!deleting) onCancel()
      }}
      role="presentation"
    >
      <div
        className="w-full max-w-sm rounded-box bg-base-100 p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="tally-bulk-delete-title"
      >
        <h3 id="tally-bulk-delete-title" className="font-bold text-lg">
          Delete {deletableCount} item{deletableCount === 1 ? '' : 's'}?
        </h3>
        <p className="py-3 text-sm">
          You selected {selectedCount} item{selectedCount === 1 ? '' : 's'}. This will permanently
          delete {deletableCount} of them.
          {linxupSkippedCount > 0
            ? ` ${linxupSkippedCount} Linxup-linked asset${linxupSkippedCount === 1 ? '' : 's'} will be skipped.`
            : ''}{' '}
          This cannot be undone.
        </p>
        <div className="mt-2 flex justify-end gap-2">
          <button type="button" className="btn btn-ghost" disabled={deleting} onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-error"
            disabled={deleting || deletableCount <= 0}
            onClick={onConfirm}
          >
            <FontAwesomeIcon
              icon={deleting ? faSpinner : faTrash}
              className={deleting ? 'animate-spin' : ''}
            />
            {deleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default TallyBulkDeleteConfirm
